import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService, DialogComponent, DialogConfiguration, DialogService, FilterPipe } from '@prekog/common-ui';
import { Doctor } from './doctor';
import { GetDoctorResponse } from './getdoctorresponse';
import { DeleteDoctorRequest } from './models/deletedoctorrequest';

@Component({
    selector: 'app-doctors',
    templateUrl: './doctors.component.html',
    styleUrls: ['./doctors.component.scss'],
    standalone: true,
    imports: [MatIconModule, CommonModule, RouterModule, FormsModule, FilterPipe]
})
export class DoctorsComponent implements OnInit {
    deleteDoctorUrl = '/admin/delete-doctor';
    doctors: Doctor[] = [];
    getDoctorsUrl = '/regenero/get-doctors';

    regeneroBaseUrl = '';

    searchtText = '';
    private _dialogService = inject(DialogService);

    constructor(
        public _router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('REGENERO_BASE_URL') private _regeneroBaseUrl: string,
    ) {
        this.regeneroBaseUrl = _regeneroBaseUrl;
    }

    ngOnInit(): void {
        if (!sessionStorage.getItem('token')) {
            this._router.navigateByUrl('/');
        } else {
            this.getDoctors();
        }
    }

    getDoctors() {
        this._apiRequestService
            .sendRequest<{}, GetDoctorResponse>(this.regeneroBaseUrl, {}, true, this.getDoctorsUrl)
            .subscribe((response) => {
                this.doctors = response.doctors as Doctor[];
            });
    }

    openDeleteDoctorDialog(doctor: Doctor) {
        const dialogconfiguration: DialogConfiguration = {
            messageKey: 'doctor.deleteConfirmMessage',
            targetData: doctor.name ?? ''
        };

        this._dialogService.openDialog(
            DialogComponent,
            dialogconfiguration,
            () => this._deleteDoctor(doctor)
        );
    }

    private _deleteDoctor(doctor: Doctor): void {
        const deleteDoctorRequest: DeleteDoctorRequest = {
            doctor: doctor
        };

        this._apiRequestService
            .sendRequest<DeleteDoctorRequest, HttpResponse<any>>(this.regeneroBaseUrl, deleteDoctorRequest, true, this.deleteDoctorUrl, true)
            .subscribe(() => {
                this.doctors = this.doctors.filter((existingDoctor) => existingDoctor.id !== doctor.id);
            });
    }
}
